import { NavLink, Outlet, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { ROLE_LABELS } from "./badges";
import { ShieldCheck, SquaresFour, FilePlus, ListChecks, Stamp, SignOut, ClipboardText, GearSix, MapTrifold, Notebook, BellRinging } from "@phosphor-icons/react";

const NavItem = ({ to, icon: Icon, label, testId }) => (
  <NavLink to={to} end data-testid={testId}
    className={({ isActive }) =>
      `flex items-center gap-3 px-4 py-2.5 text-sm transition-colors duration-200 border-l-2 ${
        isActive ? "border-white bg-white/10 text-white font-medium" : "border-transparent text-slate-400 hover:text-white hover:bg-white/5"
      }`}>
    <Icon size={18} />
    {label}
  </NavLink>
);

export default function Layout() {
  const { user, logout } = useAuth();

  if (user === null) {
    return <div className="min-h-screen flex items-center justify-center text-sm text-muted-foreground">Memuat...</div>;
  }
  if (user === false) {
    return <Navigate to="/login" replace />;
  }

  const isInvestigator = ["investigator_internal", "investigator_eksternal"].includes(user.role);
  const canInput = ["admin", "supervisor", "staff"].includes(user.role);
  const canApprove = ["admin", "supervisor"].includes(user.role);

  return (
    <div className="min-h-screen flex">
      <aside className="w-60 bg-slate-900 flex flex-col fixed inset-y-0 z-20">
        <div className="flex items-center gap-2.5 px-4 h-16 border-b border-white/10 text-white">
          <ShieldCheck size={24} weight="fill" />
          <div>
            <p className="font-semibold text-sm tracking-tight leading-none" style={{ fontFamily: "'Work Sans', sans-serif" }}>FraudGuard</p>
            <p className="text-[10px] text-slate-400 mt-0.5">Scoring Klaim Asuransi</p>
          </div>
        </div>
        <nav className="flex-1 py-4 space-y-0.5">
          <NavItem to="/" icon={SquaresFour} label="Dashboard" testId="nav-dashboard" />
          {canInput && <NavItem to="/klaim/baru" icon={FilePlus} label="Input Klaim" testId="nav-new-claim" />}
          <NavItem to="/klaim" icon={isInvestigator ? ClipboardText : ListChecks}
            label={isInvestigator ? "Tugas Saya" : "Antrean Klaim"} testId="nav-claims" />
          {canApprove && <NavItem to="/approval" icon={Stamp} label="Approval" testId="nav-approval" />}
          {canInput && <NavItem to="/polis" icon={Notebook} label="Data Polis" testId="nav-policies" />}
          {canInput && <NavItem to="/hotspot" icon={MapTrifold} label="Peta Hotspot" testId="nav-hotspot" />}
          {user.role === "admin" && <NavItem to="/notifikasi" icon={BellRinging} label="Notifikasi" testId="nav-notifications" />}
          {user.role === "admin" && <NavItem to="/admin" icon={GearSix} label="Pengaturan" testId="nav-admin" />}
        </nav>
        <div className="border-t border-white/10 p-4">
          <p data-testid="sidebar-user-name" className="text-sm text-white font-medium truncate">{user.name}</p>
          <p className="text-xs text-slate-400 mb-3">{ROLE_LABELS[user.role]}</p>
          <button data-testid="logout-button" onClick={logout}
            className="flex items-center gap-2 text-xs text-slate-400 hover:text-white transition-colors duration-200">
            <SignOut size={14} /> Keluar
          </button>
        </div>
      </aside>
      <main className="flex-1 ml-60 min-h-screen">
        <Outlet />
      </main>
    </div>
  );
}
